module.exports = __webpack_public_path__ + "static/media/pic_5.6e9543cd.jpg";